import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../../lib/adminApi';
import { saveAdminSession } from '../../lib/adminAuth';

const NAVY   = '#0a2540';
const ORANGE = '#F37428';
const BLUE   = '#0176CE';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await adminLogin(email, password);
      if (res.requires_2fa) {
        sessionStorage.setItem('pending_admin_id', res.admin_id);
        navigate('/admin/verify-2fa');
        return;
      }
      saveAdminSession(res.token, res.admin);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.message || 'Login failed.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logoRow}>
          <img src="https://www.masterfileai.com/hubfs/logo3.png" alt="MasterFileAI"
            style={{ height: 34, maxWidth: 180, objectFit: 'contain' }}
            onError={e => { e.target.style.display = 'none'; e.target.nextElementSibling.style.display = 'block'; }} />
          <span style={{ display: 'none', color: NAVY, fontWeight: 700, fontSize: 20 }}>MasterFileAI</span>
        </div>

        <div style={s.adminBadge}>ADMIN CONSOLE</div>
        <h1 style={s.heading}>Sign in to admin</h1>
        <p style={s.sub}>Restricted access — authorized personnel only.</p>

        {error && <div style={s.errorBox}>{error}</div>}

        <form onSubmit={handleSubmit} style={s.form}>
          <label style={s.label}>Email</label>
          <input style={s.input} type="email" placeholder="admin@masterfileai.com"
            value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
          <label style={s.label}>Password</label>
          <input style={s.input} type="password" placeholder="••••••••"
            value={password} onChange={e => setPassword(e.target.value)} required />
          <button type="submit" style={s.btn} disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in →'}
          </button>
        </form>
      </div>
    </div>
  );
}

const s = {
  page:       { minHeight: '100vh', background: NAVY, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', fontFamily: "'Inter', system-ui, sans-serif" },
  card:       { background: '#fff', borderRadius: 16, padding: '44px 40px', width: '100%', maxWidth: 400, boxShadow: '0 32px 80px rgba(0,0,0,0.4)' },
  logoRow:    { display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 24 },
  adminBadge: { background: 'rgba(10,37,64,0.06)', border: '1px solid rgba(10,37,64,0.15)', borderRadius: 6, color: NAVY, fontSize: 10, fontWeight: 700, letterSpacing: '0.12em', padding: '3px 10px', display: 'inline-block', marginBottom: 16 },
  heading:    { color: NAVY, fontSize: 22, fontWeight: 700, margin: '0 0 6px', letterSpacing: '-0.3px' },
  sub:        { color: '#94a3b8', fontSize: 13, margin: '0 0 24px' },
  errorBox:   { background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 8, color: '#dc2626', fontSize: 13, padding: '10px 14px', marginBottom: 20 },
  form:       { display: 'flex', flexDirection: 'column', gap: 6 },
  label:      { color: '#64748b', fontSize: 12, fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: 10 },
  input:      { background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, color: NAVY, fontSize: 14, padding: '11px 14px', outline: 'none', boxSizing: 'border-box', width: '100%' },
  btn:        { marginTop: 20, background: ORANGE, border: 'none', borderRadius: 8, color: '#fff', cursor: 'pointer', fontSize: 15, fontWeight: 600, padding: '13px', width: '100%' },
};
